<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="抄表导入" name="meter_export">
          <div>
            <div class="search-wrap" style="flex-direction: column">

              <div style="display: flex;flex-direction: row">
                <UploadFileSysc :host-url="host_url" :upload-url="host_url+'/admin/MeterNote/uploadFile'" v-model="excel_file">
                  <el-button size="mini" v-if="excel_file" type="primary" @click="showExcel">预览</el-button>
                  <el-button size="mini" v-if="excel_list&&excel_list.length&&excel_list_not_input_num" type="primary" @click="importExcel">导入</el-button>
                  <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取消</el-button>

                  <el-button size="mini" type="primary" @click="ERP.navigateBack()" style="margin-left: 30px;">返回</el-button>
                </UploadFileSysc>
              </div>
              <div style="display: flex;flex-direction: row;margin-top: 20px;">
                <div>
                  总条数： <span style="color: #038dce">{{excel_list_num}}</span> 条
                </div>
                <div style="margin-left: 50px">
                  未填条数： <span style="color: #ff3d00">{{excel_list_not_input_num}}</span> 条
                </div>
              </div>
            </div>
            <div class="table-wrap">
              <el-table v-if="excel_list&&excel_list.length" v-loading="loading" :data="pageData.list" :height="__TABLE_HEIGHT__" @selection-change="handleSelectionChange">
                <el-table-column
                  type="index"
                  width="50">
                </el-table-column>
                <el-table-column prop="number" label="仪表编号" align="center" width="100"></el-table-column>
                <el-table-column prop="name" label="仪表名称" align="center" width="180"></el-table-column>
                <el-table-column prop="house_name" label="所在房产" align="center" width="100"></el-table-column>
                <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="120"></el-table-column>
                <el-table-column prop="position" label="位置" align="center" width="100"></el-table-column>
                <el-table-column prop="last_last_read_time" label="上上期抄表日期" align="center" width="180"></el-table-column>
                <el-table-column prop="last_last_read_number" label="上上次抄表读数" align="center" width="180"></el-table-column>
                <el-table-column prop="last_read_time" label="上期抄表日期" align="center" width="180"></el-table-column>
                <el-table-column prop="last_read_number" label="上次抄表读数" align="center" width="180"></el-table-column>
                <el-table-column prop="read_number" label="抄表读数" align="center" width="180"></el-table-column>
                <el-table-column prop="read_time" label="抄表日期" align="center" width="180"></el-table-column><el-table-column prop="last_last_read_time" label="上上期抄表日期" align="center" width="180"></el-table-column>
                <el-table-column prop="admin_name" label="抄表人" align="center" width="180"></el-table-column>
                <el-table-column prop="remarks" label="备注" align="center" width="180"></el-table-column>
                <el-table-column prop="dosage_number" label="本次用量" align="center" width="180"></el-table-column>
                <el-table-column prop="allowance_number" label="本次余量" align="center" width="180"></el-table-column>
                <el-table-column prop="dosage_money" label="本次金额" align="center" width="180"></el-table-column>
                <el-table-column prop="customer_name" label="业主" align="center" width="180"></el-table-column>
                <el-table-column prop="rent_name" label="租户" align="center" width="180"></el-table-column>
                <el-table-column prop="magnification" label="仪表倍率" align="center" width="180"></el-table-column>
                <el-table-column prop="id" label="系统编号" align="center" width="180"></el-table-column>
              </el-table>
              <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
                <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="模板下载" name="meter_import">
          <div style="width: calc(100vw - 450px);">
            <el-descriptions :column="2" border size="mini" :label-style="{width: '100px'}">
              <el-descriptions-item label="仪表类型">
                <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
                  <el-option
                    v-for="item in meter_type_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="当前房产">
                <el-input size="mini" placeholder="请选择房产" v-model="house" clearable></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="仪表性质">
<!--                <el-radio v-for="item in meter_nature_list"-->
<!--                          :key="item.val" v-model="where.meter_nature" :label="item.val">{{ item.name }}</el-radio>-->

                <el-checkbox-group v-model="where.meter_nature_ids">
                  <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
              <el-descriptions-item label=""></el-descriptions-item>
              <el-descriptions-item label="">
                <el-button size="mini" type="primary" @click="dowExcel()" style="margin-right: 5px;">下载模板</el-button>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UploadFileSysc from "./components/UploadFileSysc";
import ErpTreeStatus from "../Common/erp-tree-status";
import CommonHelp from "../Contract/common/CommonHelp";
export default {
  name: "MeterNoteExcel",
  components: {ErpTreeStatus, UploadFileSysc},
  data () {
    return {
      host_url:"",
      loading: false,
      activeName:"meter_export",
      where:{
        meter_nature_ids:[1,2,3,4]
      },
      house:'',
      excel_list:[],
      dialogVisible:false,
      form:{
        name:"",
        xsc_code:"",
        status:"",
        invoicing_limit:"",
        refund_audit:"",
        sort:"",
        expense_category:"",
        bill_type:"",
        files:"",
        financial_code:"",
        financial_code_name:"",
        remarks:"",
      },
      house_charge_list:[],
      house_charge_item_list:[],
      excel_file:"",
      meter_type_list: [],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getMeterTypeList()
  },
  activated() {
    // this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "where.project_id":function (n) {
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    }

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    excel_list_num(){
      return this.excel_list.length
    },
    excel_list_not_input_num(){
      return this.excel_list.filter(ret=>{
        return (ret.read_time&&ret.admin_name&&ret.read_number)?true:false;
      }).length
    },
  },
  methods: {
    showExcel() {
      var that=this;
      that.loading=true;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      ERP.postRequest({
        url:"admin/MeterNote/meterImportExcelShow",
        data:{
          file:that.excel_file,
        }
      },res=>{
        if(res.code) {
          that.excel_list=res.data
          that.pageData.total=that.excel_list.length
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      let list=reObject(that.excel_list)
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
    },
    importExcel() {
      var that=this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定导入Excel表单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        ERP.postRequest({
          url:"admin/MeterNote/meterImportExcel",
          data:{
            file:that.excel_file,
          }
        },res=>{
          if(res.code) {
            that.$message.success('Excel表单导入成功');
            that.excel_list=[];
            that.excel_file=""
          }else {
            that.$message.error('Excel表单导入失败');
          }
          that.loading=false;
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    cleanImportExcel(){
      this.excel_file=""
      this.excel_list=[]
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.where.project_id = data.tree[0].pindex_id;
      this.where.house_name=tree_str;
      this.house = tree_str;
    },
    getMeterTypeList(){
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,name,expenditure_id,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.where.project_id&&(where.pindex_id=this.where.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    dowExcel(){
      if(this.house == ''){
        this.$message.error('点击左边的树选择项目');
        return false;
      }
      var that=this;
      let where=reObject(that.where);
      ERP.showLoading()
      ERP.getRequest({
        url:"admin/MeterNote/MeterExportExcel",
        data:{
          where:JSON.stringify(where),
          user_type:(that.$route.query.type||0),
        }
      },ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(__HTTP__.defaults.baseURL +ret.data)
        }
      },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
      });

    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterNoteExcel.vue